import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99997 1.6675V0H15V5H13.3333V2.84583L8.92247 7.25667L7.74414 6.07833L12.155 1.6675H9.99997Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 15V0.833333H7.5V2.50083H1.66667V13.3342H12.4992L12.495 7.50083L14.1617 7.49917L14.1675 15H0Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
